






























import { Vue, Component } from 'vue-property-decorator';
import { Slide } from 'vue-burger-menu';
import { version } from '@/version';

// noinspection JSUnusedGlobalSymbols
@Component({
  components: {
    Slide,
  },
})
export default class MainLayout extends Vue {
  displayVersion: string = `v ${version}`;
  copyright: string = `Copyright &copy; ${new Date().getFullYear()} schroeder.org`;

  onClickHome() {
    this.$router.push({ path: '/' });
  }
}
